// Import the functions you need from the SDKs you need
import { initializeApp, getApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
export const firebaseConfig = {
  "projectId": "narrative-architect-5z5tl",
  "appId": "1:238473634287:web:1dafe62a8448e67698161a",
  "storageBucket": "narrative-architect-default",
  "apiKey": "AIzaSyC5TZAo8qWCjtnd6qLiI7XU1TmoSateTCs",
  "authDomain": "narrative-architect-5z5tl.firebaseapp.com",
  "measurementId": "",
  "messagingSenderId": "238473634287"
};

// Initialize Firebase
const app: FirebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };
